/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
//css
import 'contents/assets/scss/page/mypage.scss';
//component
import Calendar from '../../../component/Inc/Calendar';
import Tab from '../../../component/Inc/Tab';

function AccountingSalary() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab01 = [
    {title: '전체', value: 0},
    {title: '본사', value: 1},
    {title: '부산', value: 2},
    {title: '이지올댓', value: 3}
  ];
  const tab02 = [
    {title: '전체', value: 0},
    {title: '미지급', value: 1},
    {title: '지급 완료', value: 2}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_6">교사수업 명세서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
              인센티브 지급
            </button>
          </div>
        </section>
        <div className="com_pg_container p_salary">
          <section className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <Calendar />
            <hr className="com_divider" />
            <div className="com_board_list__top teacher_tab_wrap">
              <Tab data={tab02} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">교사</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">수시 교사</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">담임</label>
                </div>
              </div>
            </div>
            <section className="com_board_list_wrap first">
              <div className="com_board_list_top_txt">교사인 경우</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="80" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                </colgroup>
                <thead>
                  <tr>
                    <th>날짜</th>
                    <th>교사명</th>
                    <th>총 진행 수업</th>
                    <th>기수</th>
                    <th>시수별 총액</th>
                    <th>수업 정산금액</th>
                    <th>전월분 공제</th>
                    <th>세액 공제 (3.3%)</th>
                    <th>기타 공제</th>
                    <th>공제 총 금액</th>
                    <th>차인 지급액</th>
                    <th>정산 상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2024, 05, 12</td>
                    <td>
                      <button className="btn_link" onClick={() => navigate('/Accounting/Salary/Detail')}>
                        김학생103
                      </button>
                    </td>
                    <td>45회</td>
                    <td className="td_padding_no">
                      <ul className="table_inner_list">
                        <li>1기</li>
                        <li>2기</li>
                        <li>3기</li>
                      </ul>
                    </td>
                    <td className="td_padding_no">
                      <ul className="table_inner_list">
                        <li>78,000</li>
                        <li>45,000</li>
                        <li>78,000</li>
                      </ul>
                    </td>
                    <td>78,000</td>
                    <td className="td_red">-12,000</td>
                    <td className="td_red">-10,000</td>
                    <td className="td_red">-4,000</td>
                    <td className="td_red">75,000</td>
                    <td className="td_point">798,000</td>
                    <td>
                      <button className="btn_link red">정산 대기</button>
                    </td>
                  </tr>
                  <tr>
                    <td>2024, 05, 12</td>
                    <td>
                      <button className="btn_link" onClick={() => navigate('/Accounting/Salary/DetailSub')}>
                        수시 교사 김학생103
                      </button>
                    </td>

                    <td>45회</td>
                    <td className="td_padding_no">
                      <ul className="table_inner_list">
                        <li>1기</li>
                        <li>2기</li>
                        <li>3기</li>
                      </ul>
                    </td>
                    <td className="td_padding_no">
                      <ul className="table_inner_list">
                        <li>78,000</li>
                        <li>45,000</li>
                        <li>78,000</li>
                      </ul>
                    </td>
                    <td>78,000</td>
                    <td className="td_red">-12,000</td>
                    <td className="td_red">-10,000</td>
                    <td className="td_red">-4,000</td>
                    <td className="td_red">75,000</td>
                    <td className="td_point">798,000</td>
                    <td>
                      <button className="btn_link blue">
                        김관리123
                        <br />
                        2024, 05, 12
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_red">-10,000</td>
                  <td className="bg_col"></td> <td className="bg_col"></td>
                  <td className="bg_col td_point">798,000</td>
                  <td className="bg_col"></td>
                </tfoot>
              </table>
            </section>

            <section className="com_board_list_wrap">
              <div className="com_board_list_top_txt">수시인 경우</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      회차
                      <span className="sub">(상품 구성명)</span>
                    </th>
                    <th>지급 구분</th>
                    <th>수업시간</th>
                    <th>메인</th>
                    <th>수업료</th>
                    <th>전월분 공제</th>
                    <th>세액 공제 (3.3%)</th>
                    <th>기타 공제</th>
                    <th>공제 총 금액</th>
                    <th>차인 지급액</th>
                    <th>정산 상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>자소1</td>
                    <td>
                      <button className="btn_link">정액</button>
                    </td>
                    <td>60분</td>
                    <td>메인</td>

                    <td>45,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>면접3</td>
                    <td>
                      <button className="btn_link">%</button>
                    </td>
                    <td>60분</td>
                    <td>메인</td>

                    <td>45,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td>12,000</td>
                    <td></td>
                  </tr>
                </tbody>
                <tfoot>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td> <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">12,000</td>
                  <td className="bg_col"></td>
                </tfoot>
              </table>
            </section>
            <section className="com_board_list_wrap">
              <div className="com_board_list_top_txt">논술인 경우</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                  <col width="165" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      회차
                      <span className="sub">(상품 구성명)</span>
                    </th>
                    <th>지급 구분</th>
                    <th>수업시간</th>
                    <th>메인</th>
                    <th>수업료</th>
                    <th>지목</th>
                    <th>정산금액 전달</th>
                    <th>실 수업료</th>
                    <th>정산 상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>면접3</td>
                    <td>
                      <button className="btn_link">정액</button>
                    </td>
                    <td>60분</td>
                    <td>메인</td>
                    <td>45,000</td>
                    <td>12,000</td>
                    <td>
                      홍교사103 <br />
                      5,000
                    </td>
                    <td>78,000</td>
                    <td>정산 대기</td>
                  </tr>
                  <tr>
                    <td>면접3</td>
                    <td>
                      <button className="btn_link">정액</button>
                    </td>
                    <td>60분</td>
                    <td>메인</td>
                    <td>45,000</td>
                    <td>12,000</td>
                    <td>
                      홍교사103 <br />
                      5,000
                    </td>
                    <td>78,000</td>
                    <td>정산 대기</td>
                  </tr>
                </tbody>
                <tfoot>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td> <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">12,000</td>
                  <td className="bg_col"></td>
                </tfoot>
              </table>
            </section>
            <section className="com_board_list_wrap">
              <div className="com_board_list_top_txt">담임인 경우</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                  <col width="126" />
                </colgroup>
                <thead>
                  <tr>
                    <th>과목</th>
                    <th>기수</th>
                    <th>회차</th>
                    <th>지급률 (%)</th>
                    <th>회당 단가</th>
                    <th>지급액</th>
                    <th>전월분 공제</th>
                    <th>세액 공제 (3.3%)</th>
                    <th>기타 공제</th>
                    <th>공제 총 금액</th>
                    <th>차인 지급액</th>
                    <th>정산 상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={2}>국어</td>
                    <td>
                      <button className="btn_link">1기</button>
                    </td>
                    <td>5회</td>
                    <td>10%</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>12,000</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <button className="btn_link">2기 이상</button>
                    </td>
                    <td>5회</td>
                    <td>10%</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>45,000</td>
                    <td>12,000</td>
                    <td></td>
                  </tr>
                </tbody>
                <tfoot>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td> <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">12,000</td>
                  <td className="bg_col"></td>
                </tfoot>
              </table>
              <div className="com_btn_wrap center btn_fixed right">
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </section>
          </section>
        </div>
      </div>
    </main>
  );
}

export default AccountingSalary;
